import React from 'react';
import { PageSelector } from './PageSelector';
import { StyledPDFViewerNavBar } from './PDFViewerNavBar.styled';
import { ZoomControls } from './ZoomControls';

interface PDFViewerNavNarProps {
	currentPage: number;
	totalPages: number;
	onPageChange: (newPage: number) => void;
	zoomFactor: number;
	onZoomIn: () => void;
	onZoomOut: () => void;
}

export function PDFViewerNavBar({
	currentPage,
	totalPages,
	onPageChange,
	zoomFactor,
	onZoomIn,
	onZoomOut,
}: PDFViewerNavNarProps) {
	return (
		<StyledPDFViewerNavBar>
			<div style={{ display: 'flex' }}>
				<PageSelector
					currentPage={currentPage}
					totalPages={totalPages}
					onPageChange={onPageChange}
				/>
				<ZoomControls zoomFactor={zoomFactor} onZoomIn={onZoomIn} onZoomOut={onZoomOut} />
			</div>
		</StyledPDFViewerNavBar>
	);
}
